import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useBrands(family, supplierId, category = "") {
  const [list, setList] = useState([]);

  async function getData(customSupplierId) {
    const idToUse =
      customSupplierId !== undefined ? customSupplierId : supplierId;

    const response = await post("ListarMarcas.php", {
      token: userData.token,
      familia: family,
      idProveedor: idToUse,
      categoria: category,
    });
    // console.log(
      // "LISTANDO MARCAS: ",
      // {
        // token: userData.token,
        // familia: family,
        // idProveedor: idToUse,
        // categoria: category,
      // },
      // response,
    // );
    setList(response);
  }

  useEffect(() => {
    if (supplierId && family !== "") {
      getData();
    }
  }, [family, supplierId, category]);

  return [list, getData];
}
